<template>
  <DefaultModal
    ref="DefaultModal"
    title="Incluir Nº Atendimento"
    defaultMinHeight="250"
    @close="close">
    <template
      slot="section">
      <div
        class="d-flex align-center fill-height pt-10"
        style="height: 60px;">
        <v-text-field
          label="Nº Atendimento"
          v-model="helpdeskId"
          outlined
          hide-details
          v-mask="'#######'"
        />
      </div>
    </template>

    <template
      slot="action-button">
      <v-btn
        class="ml-4 text-body-2 elevation-0"
        height="40"
        width="100"
        color="primary"
        :disabled="!helpdeskId"
        :loading="loading"
        @click="linkHelpdeskId">
        <v-icon
          left color="foreground-accent">
          fas fa-save
        </v-icon>
        Salvar
      </v-btn>
    </template>
  </DefaultModal>
</template>

<script>
import DefaultModal from '@/components/Modals/DefaultModal/DefaultModal.vue';

export default {
  name: 'LinkHelpdeskModal',

  components: { DefaultModal },

  data: () => ({
    loading: false,
    linkService: null,
    helpdeskId: null,
    itemId: null,
  }),

  methods: {
    open(item, itemId, service) {
      this.item = item;
      this.itemId = itemId;
      if (this.item.helpdeskTickets && this.item.helpdeskTickets.length > 0) {
        this.helpdeskId = this.item.helpdeskTickets[0].helpdeskTicketId;
      } else {
        this.helpdeskId = this.item.helpdeskId || null;
      }
      this.linkService = service;

      this.$refs.DefaultModal.open();
    },

    close() {
      this.helpdeskId = null;
      this.item = null;
      this.itemId = null;
    },

    async linkHelpdeskId() {
      this.loading = true;

      await this.linkService(this.itemId, this.helpdeskId)
        .then((response) => response.data)
        .then((result) => {
          this.$emit(
            'showMessage',
            { type: 'success', message: 'Nº do atendimento relacionado com sucesso!' },
          );

          setTimeout(() => {
            this.$emit('updatePage');
          }, 500);

          this.$refs.DefaultModal.close();
        })
        .catch((error) => {
          this.$emit(
            'showMessage',
            { type: 'error', message: 'Ocorreu um erro ao relacionar o número do atendimento!' },
          );
        })
        .finally(() => this.loading = false);
    },
  },
};
</script>
